export default __webpack_public_path__ + "static/media/fad-caret-up.41d5b011.svg";